import ReactOnRails from 'react-on-rails';
import { exists } from '@engine/lib/utility/exists';

function refreshComponent(componentName) {
  var components = $("script[data-component-name=\"".concat(componentName, "\"]"));

  if (!exists(components)) {
    return;
  }

  Object.keys(components).forEach(function (key) {
    if (key === 'length' || key === 'prevObject') {
      return;
    }

    var component = $(components[key]);
    var componentId = component.attr('data-dom-id');
    var componentProps = JSON.parse(component.text());
    ReactOnRails.render(componentName, componentProps, componentId);
  });
}

export default refreshComponent;